var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"content-wrapper",attrs:{"data-cy":"playground-omniview"}},[_c('div',{staticClass:"content"},[(_setup.isProjectLimitReached)?_c(_setup.ProjectLimitReached):_c(_setup.Playground)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }